import script from "./CellProperties.vue?vue&type=script&setup=true&lang=js"
export * from "./CellProperties.vue?vue&type=script&setup=true&lang=js"

import "./CellProperties.vue?vue&type=style&index=0&id=be642db4&lang=scss&scoped=true"

import exportComponent from "/media/dolar/office/office_project/oneGov-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-be642db4"]])

export default __exports__